import {
    Component,
    EventEmitter,
    Output,
    ViewChildren,
    QueryList,
    ElementRef,
    AfterViewInit,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-otp-input',
    templateUrl: './otp-input.component.html',
    styleUrls: ['./otp-input.component.scss'],
    standalone: false,
})
export class OtpInputComponent implements AfterViewInit, OnChanges {
    @Input() public code: string = '';
    @Output() public codeChange = new EventEmitter<string>();
    @Output() public codeComplete = new EventEmitter<string>();
    @ViewChildren('otpInput') public otpInputs!: QueryList<
        ElementRef<HTMLInputElement>
    >;

    public otpFields = [0, 1, 2, 3, 4, 5];
    public ngOnChanges(changes: SimpleChanges): void {
        if (
            changes['code'] &&
            changes['code'].currentValue === '' &&
            this.otpInputs
        ) {
            const inputs = this.otpInputs.toArray();
            if (inputs.length > 0 && inputs[0].nativeElement.value !== '') {
                this.clear();
            }
        }
    }

    public ngAfterViewInit() {
        // Автофокус на первый инпут при появлении компонента
        setTimeout(() => {
            this.focus();
        }, 0);
    }

    public focus() {
        const firstInput = this.otpInputs.first;
        if (firstInput) firstInput.nativeElement.focus();
    }

    public clear() {
        const inputs = this.otpInputs.toArray();
        inputs.forEach((input) => (input.nativeElement.value = ''));
        this.codeChange.emit('');
        this.focus();
    }

    public onInput(event: any, i: number) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D/g, '');

        if (value.length > 1) {
            this.fillFromPaste(value, i);
            return;
        }

        input.value = value;
        this.updateCode();

        if (value && i < 5) {
            const nextInput = this.otpInputs.toArray()[i + 1];
            if (nextInput) nextInput.nativeElement.focus();
        }
    }

    public onKeydown(event: KeyboardEvent, i: number) {
        const input = event.target as HTMLInputElement;
        const inputs = this.otpInputs.toArray();

        if (event.key === 'Backspace' && !input.value && i > 0) {
            const prevInput = inputs[i - 1];
            prevInput.nativeElement.focus();
            prevInput.nativeElement.value = '';
            this.updateCode();
        }

        if (event.key === 'ArrowLeft' && i > 0) {
            inputs[i - 1].nativeElement.focus();
        }
        if (event.key === 'ArrowRight' && i < 5) {
            inputs[i + 1].nativeElement.focus();
        }
    }

    public onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedData = event.clipboardData?.getData('text') || '';
        const digits = pastedData.replace(/\D/g, '').slice(0, 6);
        this.fillFromPaste(digits, 0);
    }

    private fillFromPaste(digits: string, startIndex: number) {
        const inputs = this.otpInputs.toArray();
        for (let i = 0; i < digits.length && startIndex + i < 6; i++) {
            inputs[startIndex + i].nativeElement.value = digits[i];
        }
        this.updateCode();

        const nextIndex = Math.min(startIndex + digits.length, 5);
        inputs[nextIndex].nativeElement.focus();
    }

    private updateCode() {
        const inputs = this.otpInputs.toArray();
        this.code = inputs.map((input) => input.nativeElement.value).join('');
        this.codeChange.emit(this.code);

        // Если все 6 цифр введены — уведомляем родителя
        if (this.code.length === 6) {
            this.codeComplete.emit(this.code);
        }
    }
}
